import { ChangeEvent } from 'react'
import { usePagination } from '@material-ui/lab/Pagination'
import { Flex, Button } from 'theme-ui'
import { NextPageArrow, PreviousPageArrow } from 'components/Icon'
import { noop } from 'utils'

export type PaginationProps = {
  total: number
  count?: number
  page?: number
  disabled?: boolean
  onPageChange?: (e: ChangeEvent<unknown>, page: number) => void
}

export function Pagination({
  total,
  page,
  count = 10,
  disabled = false,
  onPageChange = noop,
}: PaginationProps) {
  const { items } = usePagination({
    count: Math.ceil(total / count),
    onChange: onPageChange,
    page,
    disabled,
  })

  return (
    <Flex sx={{ justifyContent: 'center', alignItems: 'center' }}>
      {items.map(({ page, type, selected, ...item }, index) => {
        let children = null

        if (type === 'start-ellipsis' || type === 'end-ellipsis') {
          children = '…'
        } else if (type === 'page') {
          children = (
            <Button
              variant="buttons.pagination"
              type="button"
              sx={{
                bg: selected ? 'primary' : 'muted',
              }}
              {...item}>
              {page}
            </Button>
          )
        } else if (type === 'next') {
          children = (
            <Button
              variant="buttons.pagination"
              type="button"
              sx={{ bg: 'white' }}
              data-cy="next-page"
              {...item}>
              <NextPageArrow />
            </Button>
          )
        } else if (type === 'previous') {
          children = (
            <Button
              variant="buttons.pagination"
              type="button"
              sx={{ bg: 'white' }}
              data-cy="previous-page"
              {...item}>
              <PreviousPageArrow />
            </Button>
          )
        } else {
          children = (
            <Button
              variant="buttons.pagination"
              type="button"
              sx={{ bg: 'white' }}
              {...item}>
              {type}
            </Button>
          )
        }

        return <div key={index}>{children}</div>
      })}
    </Flex>
  )
}
